// ** Gatsby
import { Link } from "gatsby"

// ** Custom Components
import Box from "../Box"
import Container from "../Container"
import SectionAccordion from "../SectionAccordion"
import Text from "../Text"

// ** Icons
import EmailIcon from "../../icons/share-icon-email"
import TwitterIcon from "../../icons/share-icon-twitter"
import FacebookIcon from "../../icons/share-icon-fb"
import LinkedInIcon from "../../icons/share-icon-linkedin"

const SectionFaq = ({ section }: any) => {
  const { tags } = section

  return (
    <Container
      className="flex flex-col md:flex-row gap-x-[30px] w-full"
      fullWidthOnMobile={false}
      constrainedToBreakPoint
    >
      <Box className="flex-1">
        {tags.includes("content") && <SectionAccordion section={section} />}
      </Box>

      <Box className="basis-3/12 px-4 py-8 bg-gray-50 rounded-[11px] mt-10 md:mt-14">
        <Box>
          <Text
            variant="body-copy"
            className="text-blue-500 font-extrabold mb-3"
          >
            Browser Topic by Interest
          </Text>
          <ul>
            <li>
              <Link to="/" className="cursor-pointer">
                <Text
                  variant="body-copy"
                  className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                >
                  In The News
                </Text>
              </Link>
            </li>
            <li>
              <Link to="/" className="cursor-pointer">
                <Text
                  variant="body-copy"
                  className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                >
                  Marketing
                </Text>
              </Link>
            </li>
            <li>
              <Link to="/" className="cursor-pointer">
                <Text
                  variant="body-copy"
                  className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                >
                  Mortgage
                </Text>
              </Link>
            </li>
            <li>
              <Link to="/" className="cursor-pointer">
                <Text
                  variant="body-copy"
                  className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                >
                  Press
                </Text>
              </Link>
            </li>
            <li>
              <Link to="/" className="cursor-pointer">
                <Text
                  variant="body-copy"
                  className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                >
                  Refinancing
                </Text>
              </Link>
            </li>
            <li>
              <Link to="/" className="cursor-pointer">
                <Text
                  variant="body-copy"
                  className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                >
                  Reverse Mortgage
                </Text>
              </Link>
            </li>
            <li>
              <Link to="/" className="cursor-pointer">
                <Text
                  variant="body-copy"
                  className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                >
                  Tips
                </Text>
              </Link>
            </li>
          </ul>
        </Box>
        <Box className="mt-10">
          <Text
            variant="body-copy"
            className="text-blue-500 font-extrabold mb-3"
          >
            Recent Posts at 8Twelve
          </Text>
          <ul>
            <li>
              <Link to="/" className="cursor-pointer">
                <Text
                  variant="body-copy"
                  className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                >
                  How the Bank of Canada’s Interest Rate Hike Affects Variable
                  Rate Mortgages
                </Text>
              </Link>
            </li>
            <li>
              <Link to="/" className="cursor-pointer">
                <Text
                  variant="body-copy"
                  className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                >
                  8Twelve Enters into Mortgage Solution Agreement with Top-Tier
                  Canadian Banking Institution
                </Text>
              </Link>
            </li>
            <li>
              <Link to="/" className="cursor-pointer">
                <Text
                  variant="body-copy"
                  className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                >
                  Lower home prices, no recession, major inflation relief:
                  Predictions for Canada in 2023
                </Text>
              </Link>
            </li>
            <li>
              <Link to="/" className="cursor-pointer">
                <Text
                  variant="body-copy"
                  className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                >
                  Understanding Modern Mortgage Options
                </Text>
              </Link>
            </li>
            <li>
              <Link to="/" className="cursor-pointer">
                <Text
                  variant="body-copy"
                  className="text-blue-500 mb-3 hover:text-orange-500 transition-all"
                >
                  What Brokers Should Prioritize Amid Rising Rates
                </Text>
              </Link>
            </li>
          </ul>

          <Box className="flex gap-x-4 mt-10">
            <Link to="https://facebook.com/" className="w-[30px] h-[30px]">
              <FacebookIcon />
            </Link>
            <Link to="https://twitter.com/" className="w-[30px] h-[30px]">
              <TwitterIcon />
            </Link>
            <Link to="https://linkedin.com/" className="w-[30px] h-[30px]">
              <LinkedInIcon />
            </Link>
            <Link to="mailto:test@gmail.com/" className="w-[30px] h-[30px]">
              <EmailIcon />
            </Link>
          </Box>
        </Box>
      </Box>
    </Container>
  )
}

export default SectionFaq
